{
  "title": "Theme Style",
  "fontSize": "Font Size",
  "fontSizeOpts": [ "10", "11", "12", "13", "14" ],
  "inputStyle": "Input Style",
  "ripple": "Ripple Effect",
  "rippleTooltip": "The ripple effect must be applied before the page initializes; switch to another page and return for it to take effect",
  "theme": "Theme"
}